export const resetAccount = async ({ commit, state }) => {
    if(state.accessToken) {
        commit('setAccessToken');
        commit('setRefreshToken');
    }
};